import * as React from "react";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";
import { AwsProviderSelf } from "./aws/awsSelf";
import { AzureProviderSelf } from "./azure/azureSelf";
import { DigitalOceanProviderSelf } from "./digitalocean/digitaloceanSelf";
import { EphemeralProviderSelf } from "./ephemeral/ephemeralSelf";
import { GcpProviderSelf } from "./gcp/gcpSelf";
import { GenericProviderSelf } from "./generic/genericSelf";
import { HetznerProviderSelf } from "./hetzner/hetznerSelf";
import { LambdalabsProviderSelf } from "./lambdalabs/lambdalabsSelf";
import { LinodeProviderSelf } from "./linode/linodeSelf";
import { OblivusProviderSelf } from "./oblivus/oblivusSelf";
import { PaperspaceProviderSelf } from "./paperspace/paperspaceSelf";
import { TritonProviderSelf } from "./triton/tritonSelf";

interface Props {}
export const Provider: React.FC<Props> = ({}) => {
  const provider = useCpFormValue(`provider`);

  if (provider === "aws") {
    return <AwsProviderSelf />;
  }

  if (provider === "azure") {
    return <AzureProviderSelf />;
  }

  if (provider === "digitalocean") {
    return <DigitalOceanProviderSelf />;
  }

  if (provider === "ephemeral") {
    return <EphemeralProviderSelf />;
  }

  if (provider === "gcp") {
    return <GcpProviderSelf />;
  }

  if (provider === "generic") {
    return <GenericProviderSelf />;
  }

  if (provider === "hetzner") {
    return <HetznerProviderSelf />;
  }

  if (provider === "lambdalabs") {
    return <LambdalabsProviderSelf />;
  }

  if (provider === "linode") {
    return <LinodeProviderSelf />;
  }

  if (provider === "oblivus") {
    return <OblivusProviderSelf />;
  }

  if (provider === "paperspace") {
    return <PaperspaceProviderSelf />;
  }

  if (provider === "triton") {
    return <TritonProviderSelf />;
  }

  return null;
};
